import { call, delay, put, select, takeLatest } from "redux-saga/effects";
import { API_URL } from "utils/constants";
import { request } from "utils/request";
import toastService from "utils/toast";
import {
  IAvatar,
  IMySettingForm,
} from "app/containers/Features/containers/TeamSettings/container/MySetting/types";
import { selectFormValues } from "app/containers/Features/containers/TeamSettings/container/MySetting/redux/selector";
import { actions } from "app/containers/Features/containers/TeamSettings/container/MySetting/redux/slice";
import { actions as membersActions } from "app/containers/Features/components/MemberSelection/redux/slice";
import { handleApiError } from "utils/errorHandler";

// user my profile request
function* getUserDetailsRequest() {
  try {
    yield delay(500);
    const requestURL = `${API_URL}auth/profile`;
    const options = {
      method: "GET",
    };
    yield put(actions.setLoading(true));
    const { data, err } = yield call(request, requestURL, options);
    yield put(actions.setLoading(false));
    if (err || !data) {
      handleApiError(err);
      return;
    }
    yield put(actions.setUserDetails(data?.data));
  } catch (err) {
    yield put(actions.setLoading(false));
    handleApiError(err);
  }
}

// update the full name field

function* updateFullNameRequest() {
  try {
    yield delay(500);

    const formValues: IMySettingForm = yield select(selectFormValues);
    const requestURL = `${API_URL}auth/profile/name/update`;
    const options = {
      method: "PATCH",
      body: JSON.stringify({ fullName: formValues.fullName }),
    };
    yield put(actions.setIsButtonLoading(true));
    const { data, err } = yield call(request, requestURL, options);
    yield put(actions.setIsButtonLoading(false));
    if (err || !data) {
      handleApiError(err);
      return;
    }
    yield put(
      membersActions.updateTeamMemberLocally({
        teamMemberId: formValues._id,
        changes: { name: formValues.fullName },
      }),
    );
    toastService.success(data?.message);
  } catch (err) {
    yield put(actions.setIsButtonLoading(false));
    handleApiError(err);
  }
}

// Prefrences APi Call for Update Time Format
function* updatePreferencesRequest() {
  try {
    yield delay(500);
    const formValues: IMySettingForm = yield select(selectFormValues);

    const requestURL = `${API_URL}auth/profile/preferences/update`;
    const options = {
      method: "PATCH",
      body: JSON.stringify({
        weekStart: formValues.weekStart,
        timeFormat: formValues.timeFormat,
        dateFormat: formValues.dateFormat,
      }),
    };
    yield put(actions.setIsButtonLoading(true));
    const { data, err } = yield call(request, requestURL, options);
    yield put(actions.setIsButtonLoading(false));
    if (err || !data) {
      handleApiError(err);
      return;
    }

    toastService.success(data?.message);
  } catch (err) {
    yield put(actions.setIsButtonLoading(false));
    handleApiError(err);
  }
}
// Update Country API
function* updateCountryValueRequest() {
  try {
    yield delay(500);
    const formValues: IMySettingForm = yield select(selectFormValues);
    const requestURL = `${API_URL}auth/timezone/update`;
    const options = {
      method: "PATCH",
      body: JSON.stringify({
        timezoneId: formValues.timeZone,
      }),
    };

    yield put(actions.setIsButtonLoading(true));
    const { data, err } = yield call(request, requestURL, options);
    yield put(actions.setIsButtonLoading(false));
    if (err || !data) {
      handleApiError(err);
      return;
    }

    toastService.success(data?.message);
  } catch (err) {
    yield put(actions.setIsButtonLoading(false));
    handleApiError(err);
  }
}
// Update Language API saga function
function* updateLanguageRequest() {
  try {
    yield delay(500);
    const formValues: IMySettingForm = yield select(selectFormValues);

    const requestURL = `${API_URL}auth/profile/language/update`;
    const options = {
      method: "PATCH",
      body: JSON.stringify({
        language: formValues.language,
      }),
    };
    yield put(actions.setIsButtonLoading(true));
    const { data, err } = yield call(request, requestURL, options);
    yield put(actions.setIsButtonLoading(false));
    if (err || !data) {
      handleApiError(err);
      return;
    }

    toastService.success(data?.message);
  } catch (err) {
    yield put(actions.setIsButtonLoading(false));
    handleApiError(err);
  }
}

function* updateEmailRequest(action: {
  payload: { newEmail: string; callback: () => void };
}) {
  try {
    yield delay(500);
    const requestURL = `${API_URL}auth/change-email-request`;
    const options = {
      method: "POST",
      body: JSON.stringify({
        newEmail: action.payload.newEmail,
      }),
    };
    yield put(actions.setIsButtonLoading(true));
    const { data, err } = yield call(request, requestURL, options);
    yield put(actions.setIsButtonLoading(false));
    if (err || !data) {
      handleApiError(err);
      return;
    }
    yield put(actions.setChangeEmailRequestId(data?.data?.id || ""));
    yield put(actions.clearVerifyCodeError());
    toastService.success(data?.message);
    yield call(action.payload.callback);
  } catch (err) {
    yield put(actions.setIsButtonLoading(false));
    handleApiError(err);
  }
}

function* verifyChangeEmailRequest(action: {
  payload: { code: string; id: string; callback?: () => void };
}) {
  try {
    yield delay(500);
    const requestURL = `${API_URL}auth/change-email-verify`;
    const options = {
      method: "POST",
      body: JSON.stringify({
        verificationCode: action.payload.code,
        id: action.payload.id,
      }),
    };
    yield put(actions.setIsButtonLoading(true));
    const { data, err } = yield call(request, requestURL, options);
    yield put(actions.setIsButtonLoading(false));
    if (err || !data) {
      handleApiError(err);
      return;
    }
    yield put(actions.clearVerifyCodeError());
    toastService.success(data?.message);
    if (action.payload.callback) {
      yield call(action.payload.callback);
    }
  } catch (err) {
    yield put(actions.setIsButtonLoading(false));
    handleApiError(err);
  }
}

// Update the Password Saga function
function* updatePasswordRequest(action: { payload: { callback: () => void } }) {
  try {
    yield delay(500);
    const formValues: IMySettingForm = yield select(selectFormValues);

    const requestURL = `${API_URL}auth/passwords/update-password`;

    const body = {
      newPassword: formValues.newPassword.value,
      confirmPassword: formValues.confirmPassword.value,
      ...(formValues.hasPassword && {
        oldPassword: formValues.oldPassword.value,
      }),
    };

    const options = {
      method: "PATCH",
      body: JSON.stringify(body),
    };
    yield put(actions.setIsButtonLoading(true));
    const { data, err } = yield call(request, requestURL, options);
    yield put(actions.setIsButtonLoading(false));
    if (err || !data) {
      handleApiError(err);
      return;
    }
    yield call(action.payload.callback);
    toastService.success(data?.message);
  } catch (err) {
    yield put(actions.setIsButtonLoading(false));
    handleApiError(err);
  }
}

export function* updateProfileRequest(action: {
  payload: { avatar: IAvatar; callback: () => void };
}) {
  try {
    yield delay(500);
    const formValues: IMySettingForm = yield select(selectFormValues);
    const avatar: IAvatar = action.payload.avatar;
    const requestURL = `${API_URL}auth/profile/pic/update`;
    const options = {
      method: "PATCH",
      body: JSON.stringify({
        avatar: {
          fileId: avatar.fileId,
          icon: avatar.icon,
          color: avatar.color,
        },
      }),
    };
    yield put(actions.setIsButtonLoading(true));
    const { data, err } = yield call(request, requestURL, options);
    yield put(actions.setIsButtonLoading(false));
    if (err || !data) {
      handleApiError(err);
      return;
    }
    yield put(
      membersActions.updateTeamMemberLocally({
        teamMemberId: formValues._id,
        changes: { avatar: avatar },
      }),
    );
    toastService.success(data?.message);
    yield call(action.payload.callback);
  } catch (err) {
    yield put(actions.setIsButtonLoading(false));
    handleApiError(err);
  }
}

// Update the Password Saga function
function* updateMobileNumberRequest(action: {
  payload: { mobileNumber: string; callback: () => void };
}) {
  try {
    yield delay(500);
    const { mobileNumber } = action.payload;
    const formValues: IMySettingForm = yield select(selectFormValues);
    const requestURL = `${API_URL}auth/profile/contact/update`;

    const body = {
      mobileNumber: mobileNumber,
    };

    const options = {
      method: "PATCH",
      body: JSON.stringify(body),
    };
    yield put(actions.setIsButtonLoading(true));
    const { data, err } = yield call(request, requestURL, options);
    yield put(actions.setIsButtonLoading(false));
    if (err || !data) {
      handleApiError(err);
      return;
    }
    toastService.success(data?.message);
    yield put(
      membersActions.updateTeamMemberLocally({
        teamMemberId: formValues._id,
        changes: { mobileNumber: mobileNumber },
      }),
    );
    yield put(actions.updateMobileNumberSuccess(mobileNumber));
    yield call(action.payload.callback);
  } catch (err) {
    yield put(actions.setIsButtonLoading(false));
    handleApiError(err);
  }
}
export default function* mySettingSaga() {
  yield takeLatest(actions.getUserDetails, getUserDetailsRequest);
  yield takeLatest(actions.updateFullName, updateFullNameRequest);
  yield takeLatest(actions.updatePreferences, updatePreferencesRequest);
  yield takeLatest(actions.updateCountry, updateCountryValueRequest);
  yield takeLatest(actions.updateLanguage, updateLanguageRequest);
  yield takeLatest(actions.updateEmail, updateEmailRequest);
  yield takeLatest(actions.verifyChangeEmail, verifyChangeEmailRequest);
  yield takeLatest(actions.updatePassword, updatePasswordRequest);
  yield takeLatest(actions.updateMobileNumber, updateMobileNumberRequest);
  yield takeLatest(actions.updateProfile, updateProfileRequest);
}
